import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUserManager } from '../services/auth'
import type { UserInfo } from '../types'

export const useAuthStore = defineStore('auth', () => {
  const isAuthenticated = ref(false)
  const userInfo = ref<UserInfo | null>(null)
  const loading = ref(true)

  let _initPromise: Promise<void> | null = null

  function initialize(): Promise<void> {
    if (!_initPromise) {
      _initPromise = _doInitialize()
    }
    return _initPromise
  }

  async function _doInitialize(): Promise<void> {
    const mgr = getUserManager()
    const user = await mgr.getUser()
    if (user && !user.expired) {
      isAuthenticated.value = true
      await fetchUserInfo()
    }
    loading.value = false
  }

  async function fetchUserInfo(): Promise<void> {
    const { api } = await import('../services/api')
    const realm = import.meta.env.VITE_OIDC_REALM
    userInfo.value = await api.get<UserInfo>(`/login/realms/${realm}/protocol/openid-connect/userinfo`)
  }

  function setAuthenticated(value: boolean): void {
    isAuthenticated.value = value
  }

  function clear(): void {
    isAuthenticated.value = false
    userInfo.value = null
  }

  return { isAuthenticated, userInfo, loading, initialize, fetchUserInfo, setAuthenticated, clear }
})
